namespace advisorop.identity {

    /// Switching two-factor authentication off is always for a stated number of days, and the
    /// wording that explains what happens afterwards lives here rather than in each of the five
    /// screens that offer the toggle. Five copies of a sentence about a security control is five
    /// chances for them to drift apart and for one of them to promise the wrong thing.
    ///
    /// The server is the authority on the range and re-checks it - see
    /// IdentityServices.SetTwoFactorEnabled - so this is a convenience, not a guard.
    export class TwoFactorExemption {

        static MaxDays = 90;
        static DefaultDays = 7;

        /// Asks how long two-factor should stay off. Returns the number of days, or null if the
        /// administrator cancelled or typed something unusable - in which case nothing should happen.
        static promptForDays(who: string): number {
            const answer = window.prompt(
                `Turn off two-factor authentication for ${who}?\n\n` +
                `They will sign in with a password alone until it is switched back on.\n\n` +
                `How many days should it stay off? (1 to ${TwoFactorExemption.MaxDays})`,
                String(TwoFactorExemption.DefaultDays));

            if (answer === null)
                return null;

            const days = parseInt(answer.trim(), 10);

            if (isNaN(days) || days < 1 || days > TwoFactorExemption.MaxDays) {
                toastr.error(`Enter a number of days between 1 and ${TwoFactorExemption.MaxDays}.`);
                return null;
            }

            return days;
        }

        /// What the administrator is told once it is done. The date is the point of the message:
        /// the exemption is not open-ended and somebody should know when it lapses.
        static offMessage(who: string, days: number): string {
            const until = new Date();
            until.setDate(until.getDate() + days);

            const shown = until.toLocaleDateString(undefined,
                { year: "numeric", month: "long", day: "numeric" });

            return `Two-factor authentication is off for ${who} until ${shown}. ` +
                   `It is switched back on automatically that day.`;
        }
    }
}
